import React, { useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import moment from 'moment';
import ActionButton from '../../../framework/forms/helpercomponents/buttons/ActionButton';
import * as API from '../../../framework/API/api';
import { FILEURL, TOAST_TYPES } from '../../../framework/constant/constant';
import { utility } from '../../../framework/utility/utilityProvider';
import { set } from 'react-hook-form';
import ToastNotification from '../../../components/ToastNotification';

const TransmissionListReportCollection = () => {

    const lang = useTranslation();
    const [footerMessage, setFooterMessage] = useState('');
    const [dataItem, setDataItem] = useState({
        startDate: moment(new Date()).subtract(7, 'days').format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
    });

    const borderStyle = {
        border: "1px solid #ced4da",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FAFAFA"
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const handleExport = async () => {
        setFooterMessage(lang.please_wait_export_report_message)
        const payload = {
            startDate: utility.convertStringDatetoMilliseconds(dataItem.startDate),
            endDate: utility.convertStringDatetoMilliseconds(dataItem.endDate)
        }
        let res = await API.exportTransmissionListReport(payload);
        console.log(res);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_success_message });
            setFooterMessage(lang.successfully_exported_success_message);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setFooterMessage(res.message);
        }
    }

    return (
        <div className='m-1'>
            <h1 className="page-title txt-color-bludeDark">
                <i className="fa fa-table marlr" style={{ fontSize: 20, color: 'GrayText' }} />
                <span>{lang.transmission_list_report_page_breadcrumb}</span>
            </h1>
            <div className="border p-2 form-group with-3d-effect" style={borderStyle}>
                <div className='row'>
                    <div className='col-2 form-group'>
                        <label>{lang.start_date_label} *</label>
                        <input type="date" name="startDate" className="form-control form-control-sm" value={dataItem.startDate} onChange={onChange} />
                    </div>
                    <div className='col-2 form-group'>
                        <label>{lang.end_Date_label} *</label>
                        <input type="date" name="endDate" className="form-control form-control-sm" value={dataItem.endDate} onChange={onChange} />
                    </div>
                    <div className='col mt-4'>
                        <ActionButton title={lang.export_button_tooltip} name={lang.export_button_text} onClick={handleExport} />
                    </div>
                </div>
                <strong className='text-info' style={{ fontSize: "13px" }}>{footerMessage}</strong>
            </div>
        </div>
    )
}

export default TransmissionListReportCollection